import RouteMap from '../../components/RouteMap.jsx';
import { clockAfter } from './nearby.js';

// The road from the van through a plan's surveys (POST /api/surveys/auto-plan),
// numbered in the order they'd be done. start: when it sets off ("HH:MM").
export default function PlanMap({ plan, start = '', height = 280 }) {
  if (!plan?.stops?.length) return null;
  return (
    <RouteMap
      height={height}
      fullscreen
      routes={plan.line ? [{ key: 'plan', colour: '#0B2340', line: plan.line }] : []}
      stops={plan.stops.map((s, i) => ({
        key: s.jobId,
        coord: [s.lon, s.lat],
        label: String(i + 1),
        colour: '#0B2340',
        title: `${i + 1}. ${s.address}, ${s.postcode}${start ? ` · done about ${clockAfter(start, s.doneAfterSeconds)}` : ''}`,
      }))}
      homes={plan.from?.lat != null ? [{ key: 'van', coord: [plan.from.lon, plan.from.lat], title: `${plan.from.name}’s van${plan.from.van ? ` (${plan.from.van})` : ''}`, colour: '#D9E021' }] : []}
    />
  );
}
